export default __webpack_public_path__ + "static/media/grid_view_icon_active.1e497448.svg";